<!--
  - Copyright Huesik (c) 2019.
  - 고시원 목록에서 이미지를 제외하고 하단의 정보를 보여주는 컴포넌트입니다.
  -->

<template>
  <div class="kosiwons-information-wrapper" :style="{...style}">
    <p class="title">{{kosiwonInformation.name}} {{kosiwonInformation.branch}}</p>
    <p class="money">{{kosiwonInformation.price_min}} ~ {{kosiwonInformation.price_max}} <span class="unit">만원</span></p>
    <p class="environments">
      <!--<span class="collage">서일대</span>-->
      <subway-info :traffic="getSubwayTraffic"></subway-info>
    </p>
    <p class="desc" v-if="isShowDesc">
      {{kosiwonInformation.intro}}
    </p>
    <hash-tag-list :options="getHashTagOption" v-if="kosiwonInformation.pk" :style="{maxWidth: '90%'}"></hash-tag-list>
    <!--<p class="hash-tag-list">-->
      <!--<span>#신축</span>-->
      <!--<span>#남녀층분리</span>-->
      <!--<span>#개별화장실</span>-->
    <!--</p>-->
  </div>
</template>

<script>
  import SubwayInfo from '../../components/Kosiwons/SubwayInfo'
  import HashTagList from './hashTagList'

  export default {
    name: 'KosiwonInformationFragments',
    components: {
      HashTagList,
      SubwayInfo
    },
    props: {
      isShowDesc: {
        type: Boolean,
        default: false
      },
      kosiwonInformation: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      getSubwayTraffic() {
        return this.subwayTraffic
      },
      getHashTagOption () {
        return {
          use_sex_type: this.kosiwonInformation.options.use_sex_type,
          room_type: this.kosiwonInformation.room_type,
          option_aircon: this.kosiwonInformation.options.option_aircon,
          is_elevator: this.kosiwonInformation.options.is_elevator,
          is_parking: this.kosiwonInformation.options.is_parking,
          option_doorlock: this.kosiwonInformation.options.option_doorlock,
        }
      }
    },
    data () {
      return {
        style: {},
        subwayTraffic: []
      }
    },
    methods: {
      setSubwatTraffic () {
        if (!this.kosiwonInformation.traffics_subway.hasOwnProperty('length')) {
          this.subwayTraffic = [this.kosiwonInformation.traffics_subway]
        } else {
          this.subwayTraffic = this.kosiwonInformation.traffics_subway
        }
      }
    },
    mounted () {
      this.setSubwatTraffic()
    }
  }
</script>

<style scoped lang="less">
  @import "../../assets/css/palette";

  .kosiwons-information-wrapper {
    background: @white;
    padding: 1rem;

    p {
      line-height:1.3;
      padding: 0.45rem 0;

      &:first-child {
        padding: 0 0 0.45rem 0;
      }

      &.title {
        font-weight: bold;
        text-overflow: ellipsis;
        overflow: hidden;
        /*text-align: center;*/
        white-space: nowrap;
      }

      &.money {
        font-weight: bold;
        font-size: 2rem;
        padding:0;
        color: @windows-blue;

        .unit {
          font-size: 1.6rem;
        }
      }

      &.environments {
        font-size: 1.2rem;

        .collage {
          margin-right: 0.5rem;
        }

        .subway {
          margin-left: 0.5rem;
        }
      }

      &.desc {
        font-size: 1.2rem;
      }
    }
  }

</style>
<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    // .kosiwons-information-wrapper {
    //   p {
    //     /*line-height: 1.2;*/
    //   }
    // }
  }
</style>
